import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: 'scroll',
    ...theme.scrollbarStyles
  },
  customTableCell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  buttonNewBot: {
    backgroundColor: theme.palette.green_200.main,
    color: '#fff',
    borderRadius: 8,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: theme.palette.blue_300.main,
      boxShadow: 'none'
    }
  }
}))
